import { apiGet, apiPost } from "@redriver/cinnamon";
import { getFileArrayBufferAsync } from "modules/documentHelpers";

const NAMESPACE = "BOOKING";
const ActionTypes = {
  GetBookingOverview: `${NAMESPACE}/GET_OVERVIEW`,
  GetBookingDetails: `${NAMESPACE}/GET_DETAILS`,
  GetPassengerList: `${NAMESPACE}/GET_PASSENGERS_LIST`,
  GetDocumentsList: `${NAMESPACE}/GET_BOOKING_DOCUMENTS`,
  DownloadDocument: `${NAMESPACE}/DOWNLOAD_DOCUMENT`,
  UploadDocument: `${NAMESPACE}/UPLOAD_DOCUMENT`,
};

export const getBookingOverview = (id) => {
  return apiGet(ActionTypes.GetBookingOverview, `booking/${id}`, {
    viewName: "ResortRepBookingOverviewView",
  });
};

export const getBookingDetails = (id) => {
  return apiGet(ActionTypes.GetBookingDetails, `booking/${id}`, {
    viewName: "ResortRepBookingDetailsView",
  });
};

export const getPassengersList = (_, { bookingId }) => {
  return apiGet(ActionTypes.GetPassengerList, `booking/${bookingId}`, {
    viewName: "ResortRepBookingPassengersView",
  });
};

export const getBookingDocuments = (_, bookingId) => {
  return apiGet(ActionTypes.GetDocumentsList, "booking/documents", {
    bookingId,
    filter: "",
    showPortal: false,
    showTravelPack: false,
    showResortRep: true,
    showInternal: false,
  });
};

export const downloadBookingDocument = ({ fileName, filePath, bookingRef }) => {
  return apiGet(ActionTypes.DownloadDocument, "booking/documents/download", {
    bookingRef,
    filePath,
    fileName,
  });
};

export const uploadDocument = (formData, bookingId) => async (dispatch) => {
  const fileName = formData.file?.name;
  const arrayBuffer = await getFileArrayBufferAsync(formData.file);
  return dispatch(
    apiPost(
      ActionTypes.UploadDocument,
      `booking/documents?bookingId=${bookingId}&fileName=${encodeURIComponent(
        fileName
      )}&description=&comments=&showOnRepPortal=true`,
      arrayBuffer
    )
  );
};
